import styled from '@emotion/styled';

export const ScrollArea = styled.div<{ isScrollLocked: boolean }>`
  overflow: ${({ isScrollLocked }) => (isScrollLocked ? 'hidden' : 'auto')};
  width: 100%;
  height: 100%;
  touch-action: pan-x pan-y;
`;

/*
 * 스크롤 컨테이너와 분리된 콘텐츠 래퍼.
 * - 핀치 제스처 중 CSS transform 프리뷰의 단일 타깃
 * - width: max-content + margin auto로 가로 오버플로 시에도
 *   좌측이 잘리지 않게 중앙 정렬한다
 */
export const ScrollContent = styled.div`
  display: flex;
  width: max-content;
  min-width: 100%;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
  margin: 0 auto;
  gap: 16px;
`;

export const PageSlot = styled.div`
  position: relative;
  flex-shrink: 0;
`;
